// components
import { Outlet } from "react-router-dom";
import { MapboxProvider } from "../map/mapbox-provider";

export const MapLayout = () => {
  return (
    <MapboxProvider>
      <Outlet />
    </MapboxProvider>
  );
};
